import React from 'react';
import { useLocation } from '@reach/router';
import { useStaticQuery, graphql } from 'gatsby';

interface Props {
  title?: string | null;
  description?: string | null;
  image?: string | null;
}

const SEO: React.FC<Props> = ({ title, description, image }) => {
  const { pathname } = useLocation();

  const { site } = useStaticQuery<Queries.SeoQuery>(graphql`
    query Seo {
      site {
        siteMetadata {
          defaultTitle: title
          defaultDescription: description
          siteUrl
          defaultImage: image
          twitterUsername
        }
      }
    }
  `);

  const {
    defaultTitle,
    defaultDescription,
    siteUrl,
    defaultImage,
    twitterUsername,
  } = site!.siteMetadata!;

  const seo = {
    title: title ? `${title} | ${defaultTitle}` : defaultTitle,
    description: description || defaultDescription,
    image: `${siteUrl}${image || defaultImage}`,
    url: `${siteUrl}${pathname}`,
  };

  return (
    <>
      <title>{seo.title || ''}</title>
      <meta name="description" content={seo.description || undefined} />
      <meta name="image" content={seo.image || undefined} />

      <meta property="og:title" content={seo.title || undefined} />
      <meta property="og:description" content={seo.description || undefined} />
      <meta property="og:image" content={seo.image || undefined} />
      <meta property="og:url" content={seo.url || undefined} />
      <meta property="og:type" content="website" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={twitterUsername || undefined} />
      <meta name="twitter:title" content={seo.title || undefined} />
      <meta name="twitter:description" content={seo.description || undefined} />
      <meta name="twitter:image" content={seo.image || undefined} />

      <meta name="google-site-verification" content="DCl7VAf9tcz6eD9gb67NfkNnJ1PKRNcg8qQiwpbx9Lk" />
    </>
  );
};

export default SEO;
